import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { http } from "@/utils/http"
import { AxiosResponse } from "axios"
import {
  GET_ADD_PROMOS_URL,
  GET_UPDATE_DELETE_PROMO_URL,
} from "@/constants/api/endpoints"
import { CodePromoFormType, CodePromoType, } from "@/types/CodePromoType"
import { PromoBaseEnum } from "@/constants/CodePromoConstants"

// Todo review the response from the update an the create function

// Fetch all promos
export const fetchPromos = createAsyncThunk("promo/fetchPromos", async (_, thunkApi) => {
  return http
    .get<CodePromoType[]>(GET_ADD_PROMOS_URL)
    .then((res): CodePromoType[] => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a promo
export const createAsyncPromo = createAsyncThunk<CodePromoType, CodePromoFormType>(
  "promo/createAsyncPromo",
  async (promo: Partial<CodePromoFormType>, thunkApi) => {
    return http
      .post<CodePromoType>(GET_ADD_PROMOS_URL, promo)
      .then((res): CodePromoType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing promo
export const updateAsyncPromo = createAsyncThunk<CodePromoType, {
  id?: string,
  data?: Partial<CodePromoFormType | FormData>,
}>(
  "promo/updateAsyncPromo",
  async ({ id, data }: {
    id?: string,
    data?: Partial<CodePromoFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<CodePromoType>(GET_UPDATE_DELETE_PROMO_URL.replace(":id", `${id}`), data)
      .then((res): CodePromoType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing promo
export const deleteAsyncPromo = createAsyncThunk<AxiosResponse, { id: string }>(
  "promo/deleteAsyncPromo",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_PROMO_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

const initCodesPromo : CodePromoType[] = [
  // {
  //   id: "1",
  //   code: "SAVE10-25-UP",
  //   type: PromoTypeEnum.PERCENTAGE,
  //   base: PromoBaseEnum.TOTAL,
  //   value: 10,
  //   description: "10% de réduction sur tous les plans",
  //   usage: 10,
  //   expire_at: "2025-10-11",
  //   is_active: true
  // },
  // {
  //   id: "2",
  //   code: "SAVE11-25-UP",
  //   type: PromoTypeEnum.PERCENTAGE,
  //   base: PromoBaseEnum.PER_COLLABO,
  //   value: 10,
  //   description: "10% de réduction sur tous les plans",
  //   usage: 9,
  //   expire_at: "2025-10-11",
  //   is_active: true
  // },
  // {
  //   id: "3",
  //   code: "SAVE12-25-UP",
  //   type: PromoTypeEnum.FIXED,
  //   base: PromoBaseEnum.PER_COLLABO,
  //   value: 1000000,
  //   description: "10% de réduction sur tous les plans",
  //   usage: 9,
  //   expire_at: "2025-10-11",
  //   is_active: true
  // },
  // {
  //   id: "4",
  //   code: "SAVE13-25-UP",
  //   type: PromoTypeEnum.PERCENTAGE,
  //   base: PromoBaseEnum.TOTAL,
  //   value: 10,
  //   description: "10% de réduction sur tous les plans",
  //   usage: 25,
  //   expire_at: "2025-9-11",
  //   is_active: false
  // },
]

// initial state
const initialState: {
  promos: CodePromoType[],
  promosStatus: string,
  promosErrors?: any,

  addPromoStatus: string,
  addPromoErrors?: any,

  deletePromoErrors?: any,
  deletePromoStatus: string,
} = {
  promos: initCodesPromo,
  promosStatus: "idle",
  addPromoStatus: "idle",
  deletePromoStatus: "idle",
}

const promosSlice = createSlice({
  name: "promos",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all promos
    builder
      .addCase(fetchPromos.pending, (state) => {
        state.promosStatus = "loading"
      })
      .addCase(fetchPromos.fulfilled, (state, action) => {
        state.promosStatus = "succeeded"
        state.promos = action.payload
      })
      .addCase(fetchPromos.rejected, (state, action) => {
        state.promosStatus = "failed"
        state.promosErrors = action.error
      })

    builder
      .addCase(createAsyncPromo.pending, (state) => {
        state.addPromoStatus = "loading"
      })
      .addCase(createAsyncPromo.fulfilled, (state, action) => {
        state.addPromoStatus = "succeeded"
        state.promos = [action.payload, ...state.promos]

      })
      .addCase(createAsyncPromo.rejected, (state, action) => {
        state.addPromoStatus = "failed"
        state.addPromoErrors = action.error
      })

    builder
      .addCase(updateAsyncPromo.pending, (state) => {
        state.promosStatus = "loading"
      })
      .addCase(updateAsyncPromo.fulfilled, (state, action) => {
        state.promosStatus = "succeeded"
        let index = state.promos.findIndex(promo => promo.id === action.meta.arg.id)
        state.promos[index] = action.payload
        // if (index >= 0) {
        //   state.promos.splice(index, 1)
        //   state.promos.reverse()
        //   state.promos.unshift(action.payload)
        //   state.promos.reverse()
        // }

      })
      .addCase(updateAsyncPromo.rejected, (state, action) => {
        state.promosStatus = "failed"
        state.promosErrors = action.error
      })

    builder
      .addCase(deleteAsyncPromo.pending, (state) => {
        state.deletePromoStatus = "loading"
      })
      .addCase(deleteAsyncPromo.fulfilled, (state, action) => {
        state.promosStatus = "succeeded"
        state.promos = state.promos.filter((promo) => promo.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncPromo.rejected, (state, action) => {
        state.deletePromoStatus = "failed"
        state.deletePromoErrors = action.error
      })

  },
})

export default promosSlice.reducer

